// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"main": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^default\-webpack_sharing_consume_default_(a(ngular(_(animations_(angular_animations|browser_angular_animations_browser)|co(mmon_(angular_common|http_angular_common_http)|re_(angular_core|rxjs\-interop_angular_core_rxjs\-interop))|(platform\-browser_angular_platform\-brows|router_angular_rout)er)|\-architects_ngrx\-toolkit_angular\-architects_ng\-0c86f4)|zure_msal\-(angular_azure_msal\-angula|browser_azure_msal\-browse)r)|ngrx_signals_(events_ngrx_signals_event|ngrx_signal)s|progress_kendo\-(angular\-(d(ateinputs_progress_kendo\-angu\-fed2bb|ialog_progress_kendo\-angular\-dialog|ropdowns_progress_kendo\-angul\-8da06e)|i(n(dicators_progress_kendo\-angu\-7a54fd|puts_progress_kendo\-angular\-inputs|tl_progress_kendo\-angular\-intl)|cons_progress_kendo\-angular\-icons)|p(ager_progress_kendo\-angular\-pager|opup_progress_kendo\-angular\-popup|rogressbar_progress_kendo\-ang\-363fe1)|buttons_progress_kendo\-angular\-630eef|common_progress_kendo\-angular\-common|l10n_progress_kendo\-angular\-l10n|label_progress_kendo\-angular\-l\-31b8bd|navigation_progress_kendo\-angu\-4f0499|utils_progress_kendo\-angular\-utils)|(drawing_progress_kendo\-draw|licensing_progress_kendo\-licens)ing|intl_progress_kendo\-intl|svg\-icons_progress_kendo\-svg\-icons)|rxjs_(operators_rxjs_operator|rxj)s|jsverse_transloco_jsverse_transloco|mnp\-firm\-it_angular\-ui\-components_mnp\-firm\-it_angular\-45e276|mpm_ui_mpm_ui\-webpack_sharing_consume_default_progres\-366124)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

// no on chunks loaded

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}

}

var chunkLoadingGlobal = self["webpackChunkinvoice"] = self["webpackChunkinvoice"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));